import { filterFramesByFormId } from './filters';

function getFrameState(iframe) {
  try {
    return iframe.getValue();
  } catch (e) {
    return null;
  }
}

export function getFormState(formId) {
  return filterFramesByFormId(formId).map(getFrameState);
}

export function notifyFieldsAboutChange(formId, fieldName, fieldValue) {
  filterFramesByFormId(formId)
    .filter((frame) => frame !== window)
    .forEach((frame) => {
      try {
        if (typeof frame.updateGlobalFormState === 'function') {
          frame.updateGlobalFormState(fieldName, fieldValue);
        }
        // eslint-disable-next-line no-empty
      } catch (e) {}
    });
}
